import axios from "axios";
import ApiCall from "../constants/Api";

export const helpAxios = (svc, endpoint, options, session) => {
  if (endpoint === ApiCall.PING || endpoint === ApiCall.PING_LEGACY) {
    return axios
      .get(window.config.SiteConfig.PROXYSEC_SVC + "/" + endpoint, {
        headers: {
          "X-SESSIONID": session,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        return { error: err };
      });
  }

  if (
    endpoint === ApiCall.LOGIN_USER ||
    endpoint === ApiCall.LOGOUT_USER ||
    endpoint === ApiCall.GET_MY_IP ||
    endpoint === ApiCall.ONLINE_RESET_USER_PASSWORD ||
    endpoint === ApiCall.INVOKE_GET_METHOD
  ) {
    return axios
      .post(window.config.SiteConfig.PROXYSEC_SVC + "/" + endpoint, options, {
        headers: {
          "X-SESSIONID": session,
        },
      })
      .then((response) => {
        if (response.data) {
          if (response.data.OutParams.Result !== 0) {
            return {
              error: response.data.OutParams.ErrMsg,
              errorCode: response.data.OutParams.Result,
              data: response.data,
            };
          } else {
            return response.data;
          }
        } else {
          return { error: "Error in call " + endpoint };
        }
      })

      .catch((err) => {
        return { error: err + ", error in call " + endpoint };
      });
  } else {
    let request = {
      ServiceName: svc,
      MethodName: endpoint,
      Json: options,
    };
    return axios
      .post(
        window.config.SiteConfig.PROXYSEC_SVC + "/" + ApiCall.INVOKE_METHOD,
        request,
        {
          headers: {
            "X-SESSIONID": session,
          },
        }
      )
      .then((response) => {
        if (response.data) {
          const res = response.data;

          if (res.OutParams.Result !== 0) {
            return {
              error: res.OutParams.ErrMsg,
              Result: res.OutParams.Result,
            };
          }

          const json = res.Json || {};
          const result =
            typeof json.Result !== "undefined"
              ? json.Result
              : json.OutParams?.Result;

          if (result !== 0) {
            return {
              error: json.ErrMsg || json.OutParams?.ErrMsg || "Unknown error",
              Result: result,
            };
          }

          if (
            endpoint === ApiCall.GET_LAST_CHANGES_LOG ||
            endpoint === ApiCall.GET_FIELD_CHANGES_LOG
          ) {
            return json.Data;
          }

          return json;
        } else {
          return { error: "Error in call " + endpoint };
        }
      })

      .catch((err) => {
        return { error: err + ", error in call " + endpoint };
      });
  }
};
